import { Row, Col } from "react-bootstrap";

const TabStepper = ({ steps, currentTab }) => {
  const colSize = Math.round(12 / steps?.length);
  return (
    <Row
      className="proxima-regular mb-1 ms-0 d-flex flex-nowrap w-100"
      style={{ fontSize: "11px", fontWeight: 500 }}
    >
      {steps.map((step, index) => {
        const stepIndex = index + 1;
        const isActive = currentTab === stepIndex;
        const isCompleted = currentTab > stepIndex;
        const isUpcoming = currentTab < stepIndex;

        // background & text colors
        let background = "#D9E8FE";
        let color = "#315D99";

        if (isActive) {
          background = "#3DA0AA";
          color = "white";
        } else if (isCompleted) {
          background = "#315D99";
          color = "white";
        }

        // arrow classes
        let arrowClass = "arrow-right-tab";
        if (isActive) arrowClass = "arrow-right-tab-active";
        else if (isCompleted) arrowClass = "arrow-right-tab-previous";

        return (
          <Col key={index} className="p-0 flex-fill text-center">
            <div
              style={{
                padding: "9.8px",
                background,
                borderRadius: "3px",
                color,
                textAlign: "center",
              }}
            >
              {step}
            </div>
            {(index < steps.length) && (
              <>
                {index < steps.length - 1 && (
                  <div className={`${arrowClass} position-relative`}></div>
                )}
                {index > 0 && (
                  <div className="arrow-right-tab-white position-relative"></div>
                )}
              </>
            )}
          </Col>
        );
      })}
    </Row>
  );
};

export default TabStepper;
